// extracted by mini-css-extract-plugin
export var fullWidthButton = "_h2-0";